import ReactMarkdown from 'react-markdown'
import { useRouter } from 'next/router'
import classNames from 'classnames/bind'
import { BannerData } from 'apps/main/layouts/GeneralLayout/type'
import styles from './Banner.module.scss'

const cx = classNames.bind(styles)

type BannerProps = {
  // x 표시 클릭 시
  onClose: () => void
  onClickLink?: () => void
  disableCloseByLink?: boolean
} & BannerData

const Banner = ({
  description = '설명',
  linkLabel = '링크',
  isToNewTab = false,
  to,
  onClose,
  onClickLink,
  disableCloseByLink = false,
}: BannerProps) => {
  const router = useRouter()

  const handleClickLink = () => {
    onClickLink?.()
    if (isToNewTab) {
      window.open(to, '_blank')
    } else {
      router.push(to)
    }
    if (!disableCloseByLink) {
      onClose()
    }
  }

  return (
    <div className={cx('container')}>
      <div className={cx('wrapper')}>
        <div className={cx('content')}>
          <ReactMarkdown className={cx('description')}>{description}</ReactMarkdown>
          {linkLabel && (
            <button className={cx('button')} onClick={handleClickLink} type="button">
              {linkLabel}
            </button>
          )}
        </div>
        <button type="button" className={cx('close')} onClick={onClose}>
          <img src="/static/images/classroom/side-bar-close.png" alt="x" />
        </button>
      </div>
    </div>
  )
}

export default Banner
